module.exports = __webpack_public_path__ + "media/images/official/voice_muu-520f7636efc7037535654f0d47342531.png";